import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  year: number;   // PR_POST_YY
  month: string;  // PR_POST_MM (01~12)
}

export interface EmployeeHeader {
  empCode: string;
  empName: string;
}

export interface SalaryItemRow {
  itemSeq: number;
  itemName: string;
  sign: string;    // "+" or "-"
  amounts: number[];
  subtotal: number;
  total: number;
}

export interface BatchGroup {
  batchNo: number;
  employees: EmployeeHeader[];
  items: SalaryItemRow[];
}

export interface GrandTotals {
  baseSalary: number;
  retirementVolDed: number;
  overtimePay: number;
  taxWithholding: number;
  laborInsurance: number;
  healthInsurance: number;
}

export interface QueryResponse {
  yearMonth: string;
  batches: BatchGroup[];
  grandTotals: GrandTotals;
  totalEmps: number;
}

export interface DefaultsResponse {
  year: number;
  month: string;
}

// ============================================================
// API Client
// ============================================================

export const pw9336Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9336/query', req);
    return res.data;
  },

  async getDefaults(): Promise<DefaultsResponse> {
    const res = await apiClient.get('/api/pw9336/defaults');
    return res.data;
  },
};
